import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./TestQuestion.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/state";
import Test from '../Test/Test';
const TestQuestion = (props) => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { questionIndex } = props;
  const { updateAnswerIndex, answerIndex, isMobile } = state;
  const [isAnswered, setAnswered] = useState(false);
  const refBtns = useRef([]);
  useEffect(()=>{
    const btns = refBtns.current;
    if(isMobile){
      btns.forEach(element => {
        element.classList.add(styles.mobile);
      });
    }else{
      btns.forEach(element => {
        element.classList.remove(styles.mobile);
      });
    }
  },[isMobile]);
  const clickHandler = (id) => {
    const array = [...answerIndex];
    const btns = refBtns.current;
    array[questionIndex] = id;
    updateAnswerIndex(array);
    if (id === -1) {
      setAnswered(false);
      btns.forEach((item)=>{
        item.classList.remove(styles.active);
        item.classList.remove(styles.disable);
      });
    } else {
      setAnswered(true);
      btns[id].classList.add(styles.active);
      btns[1-id].classList.add(styles.disable);
    }
  }
  return (
    <>
      <div className={styles.wrap}>
        <Test>
          <>
            {props.children.length > 0 ?
              props.children[0]
              : null
            }
          </>
          <>
            {props.children.length > 0 ?
              props.children[1]
              : null
            }
            <div className={styles.btns}>
              <div className={`${styles.btn} ${styles.btn_black}`} onClick={() => { clickHandler(1) }} ref={element=>refBtns.current[1] = element}>Поддерживаю</div>
              <div className={styles.btn} onClick={() => { clickHandler(0) }} ref={element=>refBtns.current[0] = element}>Подумаю</div>
            </div>
            {isAnswered ?
              <div className={styles.reset} onClick={() => { clickHandler(-1) }}>Отменить выбор</div>
              :
              null
            }
          </>
        </Test>
      </div>
    </>
  );

}

export default TestQuestion;
